import { useParams } from "react-router-dom";
import { LeadsBrowser } from "../leads/LeadsBrowser";

/**
 * Review Leads (screens.md §5) — the campaign's own result set, with search,
 * filters, pagination, manual selection + bulk approve/reject, and a
 * deep-linkable detail drawer (ADR-0020). Locked to this campaign.
 */
export function LeadsTab() {
  const { id: campaignId } = useParams<{ id: string }>();
  return <LeadsBrowser campaignId={campaignId} />;
}
